import { render, staticRenderFns } from "./IlSignupStoryLibAdapter.vue?vue&type=template&id=70978bea&scoped=true"
import script from "./IlSignupStoryLibAdapter.vue?vue&type=script&lang=js"
export * from "./IlSignupStoryLibAdapter.vue?vue&type=script&lang=js"
import style0 from "./IlSignupStoryLibAdapter.vue?vue&type=style&index=0&id=70978bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70978bea",
  null
  
)

export default component.exports